import { useMutation, useQueryClient } from '@tanstack/react-query';
import { housingStatusApi } from '../api/housingStatus.api';
import { housingStatusKeys } from '../api/housingStatus.keys';
import toast from 'react-hot-toast';

export function useCreateHousingStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => housingStatusApi.create(data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: housingStatusKeys.all }); toast.success('Housing status created'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to create'); },
  });
}

export function useUpdateHousingStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => housingStatusApi.update(id, data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: housingStatusKeys.all }); toast.success('Housing status updated'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to update'); },
  });
}

export function useDeleteHousingStatus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => housingStatusApi.delete(id),
    onSuccess: () => { qc.invalidateQueries({ queryKey: housingStatusKeys.all }); toast.success('Housing status deleted'); },
    onError: (err: any) => { toast.error(err.response?.data?.message || 'Failed to delete'); },
  });
}
